import { ApiResponse } from '@shared/models/api.model';
import axiosInstance from '../axios-instance';
import { RadioModel } from '@modules/entertainment/models/radio.model';

export const getRadio = async (
  params?: any
): Promise<ApiResponse<RadioModel>> => {
  const response = await axiosInstance.get('/media/radios/getter', { params });
  return response.data;
};

export const createRadio = async (
  body?: any
): Promise<ApiResponse<RadioModel>> => {
  return await axiosInstance.post(`/media/radios`, body);
};

export const editRadioRow = async (
  body: any,
  id: any
): Promise<ApiResponse<RadioModel>> => {
  return await axiosInstance.put(`/media/radios/${id}`, body);
};

export const deleteRadio = async (id: string): Promise<void> => {
  return await axiosInstance.delete(`/media/radios/${id}`);
};

export const deleteRadiosMany = async (id: string[]): Promise<void> => {
  const data = { ids: id };
  await axiosInstance.delete(`/media/radios/many`, { data });
};
